import { SsoSDK } from '@q-auth/auth-sdk'
import { rememberLoginSource, clearLoginSource } from './loginBackRecovery'
import {
  FAT_AUTH_ORIGIN,
  FAT_CLIENT_ID,
  QAUTH_POOL_CODE,
  getOAuthSiteOrigin,
  getOAuthCallbackUrl,
  OAUTH_PENDING_KEY,
  getOAuthReturnUrl,
} from './oauth'

let loginStarted = false

// 从认证页后退恢复时允许再次点击上传/登录，不能沿用离开前的防重入状态。
window.addEventListener('pageshow', (event) => {
  if (event.persisted) loginStarted = false
})

// 与头部登录共用认证中心、回调地址和安全状态校验。
export function startLogin(previousSdk = null, returnTo = window.location.href) {
  if (loginStarted) return previousSdk
  loginStarted = true
  try {
    if (!QAUTH_POOL_CODE) throw new Error('缺少 QAuth 用户池 code，请配置后重试。')
    const returnUrl = getOAuthReturnUrl(returnTo, getOAuthSiteOrigin())
    const state = Array.from(crypto.getRandomValues(new Uint8Array(24)), (byte) =>
      byte.toString(16).padStart(2, '0'),
    ).join('')
    sessionStorage.setItem(
      OAUTH_PENDING_KEY,
      JSON.stringify({ state, returnUrl: returnUrl.href }),
    )
    previousSdk?.destroy()
    const sdk = new SsoSDK({
      client_id: FAT_CLIENT_ID,
      code: QAUTH_POOL_CODE,
      sso_origin: FAT_AUTH_ORIGIN,
      authorize_uri: `${FAT_AUTH_ORIGIN}/api/oauth2/authorize`,
      redirect_uri: getOAuthCallbackUrl(),
      response_type: 'code',
      scope: ['openid', 'profile', 'email', 'phone'],
      state,
    })
    rememberLoginSource()
    sdk.login()
    return sdk
  } catch (error) {
    clearLoginSource()
    loginStarted = false
    console.error('QAuth 登录发起失败', error)
    window.alert(error?.message || '无法发起登录，请稍后重试。')
    return previousSdk
  }
}

export function handleUnauthorized() {
  // 登录回调本身失败时由回调页展示错误，避免自动登录循环。
  if (/\/auth\/(?:start|callback)\/?$/.test(window.location.pathname)) return
  startLogin()
}
